module.exports = __webpack_public_path__ + "img/VoIP.12a06a6d.gif";